<template>

  <div class="feed-content">
    <div
      class="photo"
      v-if="activity.author_user">
      <Avatar
        :src="imgSrc"
        :name="activity.author_user.name"
        size="40px"
        radius="20px"
        resize="100x100x1" />
    </div>
    
    <div class="content">
      <div><strong>movido para</strong> {{ activity.move.stage_id.name }}</div>
      <div>
        <small>
          <span
            v-tooltip="$d(new Date(activity.created_at), 'long')">
            {{ $d(new Date(activity.created_at), 'short') }}
            </span>
          <span
            v-if="activity.author_user">
            por {{ activity.author_user.name }}
            </span>
          <span>
            -
            </span>
          <router-link
            class="link-discreet"
            :to="{path: '/job/' + activity.job._id }">
            {{ activity.job.title }}
            </router-link>
        </small>
      </div>
    </div>
  </div>

</template>

<script>
import config from '@/config'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'CandidateMoveItem',
  components: {
    Avatar
  },
  props: [
    'activity'
  ],
  data () {
    return {
    }
  },
  computed: {
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.activity.author_user.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Feed/CandidateFeedMoveItem.vue